/**
 *  Normalizes data into chunks of a given size, to ensure that the smallest
 *  amounts are visible. For example, if the chunk size is 5, then 0-5 will be
 *  normalized to 1, 6-10 will be normalized to 2, etc.
 * @param data
 *
 * example with minPercentage of 5:
 * 0 => 0
 * 1 => 5
 * 2 => 5
 * 3 => 5
 * 50 => 50
 * 95 => 95
 * 99.999 => 95
 */
export function normalizeData<T extends PercentageData>(
  data: T[],
  { minimumPercentage }: { minimumPercentage: number }
): NormalizedPercentageData<T>[] {
  return data.map((item) => {
    let normalizedPercentage: number;

    if (item.percentage === 0) {
      normalizedPercentage = 0;
    } else if (item.percentage > 0 && item.percentage <= minimumPercentage) {
      normalizedPercentage = minimumPercentage;
    } else {
      normalizedPercentage =
        Math.floor(item.percentage / minimumPercentage) * minimumPercentage;
    }

    return {
      ...item,
      normalizedPercentage: normalizedPercentage,
    };
  });
}

type PercentageData = {
  percentage: number;
};

type NormalizedPercentageData<T extends PercentageData> = T & {
  normalizedPercentage: number;
};
